// extracted by mini-css-extract-plugin
export default {"table":"F4uzd6oONMuwmDz2Kwej"};